import math from "core/math";
import { default as correctShift } from "./correctShift.js";
import { default as changeViewportScale } from "./changeViewportScale.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import CustomEvent from "core/customEvent/index";

class ZoomTool {
  constructor() {
    this.invert = false;
    this.maxScale = 20.0;
    this.minScale = 0.25;
    this.preventZoomOutsideImage = false;
  }
  onMouseDrag = evt => {
    const eventData = evt.detail;

    const invert = this.invert;
    const maxScale = this.maxScale;
    const minScale = this.minScale;

    let viewportObject = eventData.viewportObject;

    const deltaY = evt.detail.deltaPoints.page.y;
    const ticks = invert ? -deltaY / 100 : deltaY / 100;
    const { element } = evt.detail;
    const [startX, startY, imageX, imageY] = [
      evt.detail.startPoints.page.x,
      evt.detail.startPoints.page.y,
      evt.detail.startPoints.image.x,
      evt.detail.startPoints.image.y
    ];

    // Calculate the new scale factor based on how far the mouse has changed
    const updatedViewport = changeViewportScale(
      eventData.element.viewport,
      ticks,
      {
        maxScale,
        minScale
      }
    );

    //viewportObject.setViewport(element, updatedViewport);
    viewportObject.setViewport(updatedViewport);

    // Now that the scale has been updated, determine the offset we need to apply to the center so we can
    // Keep the original start location in the same position
    const newCoords = math.coordinate.pageToPixel(element, startX, startY);

    // The shift we will use is the difference between the original image coordinates of the point we've selected
    // And the image coordinates of the same point on the page after the viewport scaling above has been performed
    // This shift is in image coordinates, and is designed to keep the target location fixed on the page.
    let shift = {
      x: imageX - newCoords.x,
      y: imageY - newCoords.y
    };

    // Correct the required shift using the viewport rotation and flip parameters
    shift = correctShift(shift, updatedViewport);

    // Apply the shift to the Viewport's translation setting
    eventData.element.viewport.translation.x -= shift.x;
    eventData.element.viewport.translation.y -= shift.y;

    // Zoom 변경에 따른 이벤트 발생
    var elementStub = getEnabledElement(eventData.element.element);
    CustomEvent.triggerEvent(
      eventData.element.element,
      CustomEvent.EVENTS.PAN_ZOOM_CHANGED,
      elementStub
    );
  };
}

// Module exports
export default ZoomTool;
